// extracted by mini-css-extract-plugin
module.exports = {"label":"PresetOptions_label__PGTd8","iconWrapper":"PresetOptions_iconWrapper__5urXn"};